export const isOffScreen = (node) => {
    const elementsRect = node.getBoundingClientRect();
    const tooHigh = elementsRect.top < 0;
    const tooLow = elementsRect.top + elementsRect.height > document.documentElement.clientHeight;
    return tooHigh || tooLow;
};
//# sourceMappingURL=is-off-screen.js.map